<style lang="scss" scoped>
/* W3C standard
   сейчас только для Firefox */
   * {
  scrollbar-width: thin;
  scrollbar-color: var(--v-primary-base) rgba(166, 209, 137, 0.2);
}

/* для Chrome/Edge/Safari */
*::-webkit-scrollbar {
  width: 8px;
}
*::-webkit-scrollbar-track {
  background: rgba(166, 209, 137, 0.2);
  border-radius: 4px;
}
*::-webkit-scrollbar-thumb {
  background: var(--v-primary-base);
  border-radius: 4px;
}

.attention {
  margin-left:-36px;
}
.has-left-border {
  border-left: 3px solid  var(--v-primary-base);
}
.has-scroll {
  height: 720px;
  overflow-y: auto;
  overflow-x: hidden;
}
.w-form {
  padding-left: 112px;
  padding-right: 50px;
}

.pl-custom-title{
  padding-left: 70px;
}

.f-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: 0em;
    color: var(--v-secondary-base);
}

.baseform {
    border: 2px solid var(--v-primary-base);
    border-radius: 0;
    background: radial-gradient(80.5% 109.72% at 69.19% 61.17%, rgba(191, 255, 232, 0.2) 3.93%, rgba(213, 255, 253, 0) 34.45%) 
    /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */, 
    linear-gradient(250.45deg, #CAFFA9 -61.89%, #FFFFFF 34.74%);

    .nopercent {
        position: absolute; 
        top:0;
        width: 275px;
        height: 31px; 
        background: linear-gradient(272.29deg, #91DC60 16.26%, #00D5D5 168.81%);
        border-radius: 0px 0px 2px 2px;
        color: white;
        font-size: 14px;
        line-height: 28px;
        text-transform: uppercase;
    }
}


</style>

<template>
    <v-row class="baseform mb-5">
        <v-col 
            cols="12" 
            align="center"
            >
            <div class="nopercent">
              Лидер среди МФО по выдачам
            </div>
            <img 
                class="attention pt-10 pb-15" 
                :src="require('./../../assets/logo.png')" alt=""
                >
        </v-col>

        <v-col cols="12" md="5">
            <Cards />
        </v-col>
        
        <v-col 
            cols="12" md="7"
            :class="{'has-left-border': mdAndUp}"
            class="pl-0 pt-0"
            >
            <div class="d-flex align-center ml-0 pl-0 mt-0">
                <img 
                    v-if="mdAndUp"
                    class="attention" 
                    src="../../assets/attention.png" alt=""
                    >
                <div 
                    :class="{'pl-custom-title': mdAndUp}"
                    class="f-title mx-auto"
                    >
                    <slot name="title"></slot>
                </div>
            </div>

            <div :class="{'w-form has-scroll': mdAndUp}" class="mx-4">
                <slot></slot>
            </div>
        </v-col>

        <v-col 
            offset-md="5"
            cols="12" md="7"
            :class="{'w-form': mdAndUp}"
            >
            <slot name="buttons"></slot>          
        </v-col>
      
    </v-row>
</template>

<script>
export default {
    computed: {
        mdAndUp() {
            return this.$vuetify.breakpoint.mdAndUp;
        }
    }
}
</script>